import { render, staticRenderFns } from "./ProjectTask.vue?vue&type=template&id=1de1d0fb&scoped=true&"
import script from "./ProjectTask.vue?vue&type=script&lang=js&"
export * from "./ProjectTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de1d0fb",
  null
  
)

export default component.exports